// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 6: رحلات بولس التبشيرية
// ============================================================================
// المستويات 66-78 (13 مستوى، 39 سؤال)

export const chapter6Translations = {
  name: "رحلات بولس التبشيرية",
  description: "إلى أقاصي الأرض...",
  
  spiritualWisdom: {
    principle: "الإنجيل هو لجميع الأمم ويجب أن يُكرز به في العالم كله",
    scripture: "اذهبوا وتلمذوا جميع الأمم (متى 28: 19)",
    application: "كل مسيحي مدعو ليكون شاهداً للمسيح في المكان الذي وضعه الله فيه"
  },
  
  levels: {
    66: {
      name: "الرحلة التبشيرية الأولى",
      challenge: "أفرزوا لي برنابا وشاول للعمل الذي دعوتهما إليه...",
      easy: {
        question: "من رافق بولس في رحلته الأولى؟",
        options: ["بطرس", "برنابا", "سيلا", "تيموثاوس"],
        hint: "'ابن التعزية'",
        funFact: "👥 برنابا قَبِل بولس بعد ارتداده - شراكة إلهية!"
      },
      medium: {
        question: "من أي مدينة انطلقوا في البعثة؟",
        options: [
          "أورشليم",
          "أنطاكية سوريا",
          "طرسوس",
          "دمشق"
        ],
        hint: "أول كنيسة مختلطة من اليهود والأمم",
        funFact: "🚢 أنطاكية: ميناء الانطلاق لتبشير العالم الغربي!"
      },
      hard: {
        question: "ماذا تكشف هذه الرحلة الأولى عن استراتيجية التبشير؟",
        options: [
          "يجب البقاء في منطقتك",
          "الإنجيل يتجاوز كل الحدود الثقافية",
          "اليهود فقط يمكن خلاصهم",
          "التبشير اختياري"
        ],
        hint: "يتعلق بعالمية الرسالة",
        funFact: "🌊 عبور المتوسط = الخطوة الأولى نحو تبشير العالم!"
      }
    },
    
    67: {
      name: "في قبرص مع عليم",
      challenge: "يا ممتلئاً من كل غش وكل خبث، يا ابن إبليس...",
      easy: {
        question: "من هو الساحر الذي عارض بولس في قبرص؟",
        options: ["سيمون", "عليم", "أبلوس", "ألكسندر"],
        hint: "نبي كاذب حاول إضلال الوالي",
        funFact: "🪄 أول مواجهة مباشرة بين الإنجيل والسحر!"
      },
      medium: {
        question: "ما العقوبة التي أنزلها بولس بعليم؟",
        options: [
          "طرده",
          "أعماه مؤقتاً",
          "تجاهله",
          "جادله"
        ],
        hint: "عمى مؤقت لفتح العيون الروحية",
        funFact: "👁️ مفارقة إلهية: من أعمى النفوس صار أعمى مؤقتاً!"
      },
      hard: {
        question: "كيف تُظهر هذه الحادثة قوة الإنجيل؟",
        options: [
          "العنف ضروري",
          "حق الله ينتصر على الباطل",
          "يجب محاربة كل السحرة",
          "بولس كان انتقامياً"
        ],
        hint: "يتعلق بسلطان الله على الخداع",
        funFact: "⚡ الوالي آمن بعد رؤية قوة الله - شهادة فعالة!"
      }
    },

    68: {
      name: "في أنطاكية بيسيدية",
      challenge: "كان ينبغي أن تُبشَّروا بكلمة الله أولاً...",
      easy: {
        question: "أين كان بولس يبشر أولاً عند وصوله لمدينة؟",
        options: [
          "في الساحة العامة",
          "في المجمع أولاً",
          "في بيت الأغنياء",
          "في معبد وثني"
        ],
        hint: "كان يبدأ دائماً بشعبه",
        funFact: "🕍 استراتيجية التبشير: أولاً لليهود، ثم للأمم!"
      },
      medium: {
        question: "كيف استجاب اليهود لرسالة بولس؟",
        options: [
          "قبلوا جميعاً",
          "انقسموا: بعضهم آمن وبعضهم عارض",
          "بقوا غير مبالين",
          "طردوه فوراً"
        ],
        hint: "انقسام نموذجي على الإنجيل",
        funFact: "⚖️ الإنجيل دائماً يقسّم: قبول أو رفض، لا لامبالاة!"
      },
      hard: {
        question: "لماذا يتوجه بولس إلى الأمم؟",
        options: [
          "كان يفضل الأمم",
          "رفض اليهود يفتح الباب للأمم",
          "كان أسهل",
          "تخلى عن الرسالة"
        ],
        hint: "يتعلق بتحقيق النبوة",
        funFact: "🚪 'نور للأمم' - نبوة إشعياء تتحقق من خلال بولس!"
      }
    },

    69: {
      name: "الشفاء في لسترة",
      challenge: "الآلهة تشبهوا بالناس ونزلوا إلينا!",
      easy: {
        question: "ماذا شفى بولس في لسترة؟",
        options: [
          "أعمى",
          "رجل أعرج منذ الولادة",
          "أصم أبكم",
          "أبرص"
        ],
        hint: "شخص لم يمشِ قط",
        funFact: "🦵 معجزة مذهلة: 'قم على رجليك منتصباً!' - إيمان شافٍ!"
      },
      medium: {
        question: "من ظن الجمع أن بولس وبرنابا هما؟",
        options: [
          "ملوك",
          "آلهة (زيوس وهرمس)",
          "سحرة",
          "أنبياء"
        ],
        hint: "آلهة الأساطير اليونانية",
        funFact: "⚡ برنابا = زيوس (وقور)، بولس = هرمس (فصيح) - سوء فهم ثقافي!"
      },
      hard: {
        question: "كيف استجاب بولس لهذه العبادة الوثنية؟",
        options: [
          "قَبِل التكريم",
          "مزق ثيابه ووعظ بالإله الحقيقي",
          "صمت بأدب",
          "استغل الوضع"
        ],
        hint: "رفض تام للوثنية",
        funFact: "👔 تمزيق الثياب = فزع يهودي من الوثنية - صدق تام!"
      }
    },

    70: {
      name: "الرجم والقيامة",
      challenge: "وبينما التلاميذ يحيطون به، قام ودخل المدينة...",
      easy: {
        question: "ماذا فعل أهل لسترة ببولس؟",
        options: [
          "سجنوه",
          "رجموه",
          "نفوه",
          "صلبوه"
        ],
        hint: "عقوبة يهودية تقليدية",
        funFact: "🪨 من 'إله' إلى 'ميت' في يوم واحد - تقلب الجموع البشرية!"
      },
      medium: {
        question: "ماذا فعل بولس بعد الرجم؟",
        options: [
          "هرب من المدينة",
          "اختبأ",
          "قام ورجع إلى المدينة",
          "ذهب للمستشفى"
        ],
        hint: "شجاعة خارقة بعد أن ظُنّ ميتاً",
        funFact: "💪 قيامة معجزية أو شفاء إلهي - شجاعة لا تُصدق!"
      },
      hard: {
        question: "ماذا تكشف هذه الاضطهادات عن ثمن الشهادة؟",
        options: [
          "يجب تجنب الصراع",
          "الشهادة للمسيح قد تكلف الحياة",
          "بولس كان متهوراً",
          "الاضطهاد عديم الجدوى"
        ],
        hint: "يتعلق بثمن شهادة الحق",
        funFact: "✝️ 'بضيقات كثيرة ينبغي أن ندخل ملكوت الله' - واقعية بولس!"
      }
    },

    71: {
      name: "مجمع أورشليم",
      challenge: "إن لم تختتنوا لا يمكنكم أن تخلصوا...",
      easy: {
        question: "ما النقاش المهم الذي دار في مجمع أورشليم؟",
        options: [
          "المعمودية",
          "ختان الأمم المتنصرين",
          "السبت",
          "التقدمات"
        ],
        hint: "هل يجب أن تصير يهودياً لتكون مسيحياً؟",
        funFact: "✂️ أول أزمة كبرى: مسيحية أم مسيحية يهودية؟"
      },
      medium: {
        question: "ما كان القرار النهائي للمجمع؟",
        options: [
          "الختان إلزامي",
          "حرية للأمم مع بعض التوصيات",
          "انفصال تام عن اليهود",
          "تأجيل القرار"
        ],
        hint: "انفتاح على الأمم دون قيود كبيرة",
        funFact: "🆓 ثورة تاريخية: الإنجيل حر من شريعة موسى!"
      },
      hard: {
        question: "ما أهمية هذا المجمع للكنيسة العالمية؟",
        options: [
          "حدث تافه",
          "يرسخ عالمية الخلاص بالإيمان فقط",
          "يقسم الكنيسة",
          "يعزز الناموسية"
        ],
        hint: "يتعلق بأساس الكنيسة العالمية",
        funFact: "🌍 لولا هذا القرار لبقيت المسيحية طائفة يهودية!"
      }
    },

    72: {
      name: "الرحلة الثانية: تيموثاوس",
      challenge: "أراد بولس أن يأخذه معه فختنه من أجل اليهود...",
      easy: {
        question: "من انضم لبولس كمعاون شاب؟",
        options: ["مرقس", "لوقا", "تيموثاوس", "تيطس"],
        hint: "'الابن الحبيب' لبولس",
        funFact: "👦 تيموثاوس: النابغة الشاب يصير اليد اليمنى لبولس - تلمذة ناجحة!"
      },
      medium: {
        question: "لماذا ختن بولس تيموثاوس رغم الحرية المكتسبة؟",
        options: [
          "بسبب واجب قانوني",
          "بسبب استراتيجية تبشيرية بين اليهود",
          "بسبب التقليد",
          "بالخطأ"
        ],
        hint: "حكمة عملية لتجنب العوائق",
        funFact: "🎯 حرية حكيمة: 'صرت للكل كل شيء لأخلص على كل حال قوماً'!"
      },
      hard: {
        question: "كيف توضح هذه المواقف مرونة التبشير؟",
        options: [
          "بولس كان غير متسق",
          "تكيف مع الأساليب دون مساومة على الإنجيل",
          "استسلم للضغط",
          "كان منافقاً"
        ],
        hint: "يتعلق بالحكمة السياقية",
        funFact: "⚖️ مبادئ ثابتة، أساليب مرنة - فن الشهادة الفعالة!"
      }
    },

    73: {
      name: "رؤيا المكدوني",
      challenge: "اعبر إلى مكدونية وأعنّا!",
      easy: {
        question: "ماذا رأى بولس في رؤيا الليل؟",
        options: [
          "ملاك",
          "رجل مكدوني يدعوه",
          "يسوع يكلمه",
          "نور عظيم"
        ],
        hint: "صرخة استغاثة من أوروبا",
        funFact: "🌉 رؤيا حاسمة: الإنجيل يعبر إلى أوروبا - نقطة تحول تاريخية!"
      },
      medium: {
        question: "ما أول مدينة أوروبية تلقت الإنجيل؟",
        options: [
          "أثينا",
          "كورنثوس",
          "فيلبي",
          "تسالونيكي"
        ],
        hint: "مستعمرة رومانية في مكدونية",
        funFact: "🏛️ فيلبي: أول كنيسة أوروبية - قارة تغيرت للأبد!"
      },
      hard: {
        question: "ماذا ترمز هذه الرؤيا للتاريخ المسيحي؟",
        options: [
          "حلم عادي",
          "توسع إلهي نحو الغرب",
          "هلوسة",
          "تغيير في الخطة"
        ],
        hint: "يتعلق بالعناية الموجهة للتاريخ",
        funFact: "🗺️ بدون هذه الرؤيا لبقيت أوروبا وثنية - خطة الله!"
      }
    },

    74: {
      name: "ليدية، أول متنصرة أوروبية",
      challenge: "ففتح الرب قلب ليدية لتصغي...",
      easy: {
        question: "ما كانت مهنة ليدية؟",
        options: [
          "خبازة",
          "بائعة أرجوان",
          "نساجة",
          "فخارية"
        ],
        hint: "تجارة الكماليات في ذلك الوقت",
        funFact: "🟣 الأرجوان = لون ملكي باهظ الثمن - ليدية كانت ثرية!"
      },
      medium: {
        question: "أين التقى بولس بليدية؟",
        options: [
          "في السوق",
          "عند مصلى بجانب النهر",
          "في بيتها",
          "في المجمع"
        ],
        hint: "مكان صلاة خارجي",
        funFact: "🏞️ لم يكن في فيلبي مجمع - صلاة بجانب الماء حسب التقليد!"
      },
      hard: {
        question: "ماذا تكشف ارتداد ليدية عن عمل الله؟",
        options: [
          "كانت مستعدة بطبيعتها",
          "الله يفتح القلوب المستعدة لقبول الكلمة",
          "كانت مصادفة",
          "بولس كان مقنعاً"
        ],
        hint: "يتعلق بعمل الله في الارتداد",
        funFact: "💝 'فتح الرب قلبها' - الله يُعِدّ ويفتح النفوس!"
      }
    },

    75: {
      name: "السجن في فيلبي",
      challenge: "وفي نصف الليل كان بولس وسيلا يصليان ويسبحان الله...",
      easy: {
        question: "لماذا سُجن بولس وسيلا؟",
        options: [
          "سرقة",
          "طرد شيطان وإزعاج النظام العام",
          "تجديف",
          "شغب"
        ],
        hint: "شفاء الجارية العرّافة",
        funFact: "💸 تحرير النفوس يكلف المستغِلين - اضطهاد اقتصادي!"
      },
      medium: {
        question: "ماذا فعل بولس وسيلا في السجن؟",
        options: [
          "تذمروا",
          "صليا وسبحوا",
          "استعدوا للدفاع",
          "ناموا"
        ],
        hint: "تسبيح رغم القيود",
        funFact: "🎵 ترانيم في السجن عند منتصف الليل - إيمان راسخ مثير للإعجاب!"
      },
      hard: {
        question: "كيف غيّرت مواقفهم الوضع؟",
        options: [
          "لم يكن لها تأثير",
          "ارتداد السجان بعد الزلزال",
          "أغضبت السجان",
          "جنّنتهم"
        ],
        hint: "شهادة قوية بالقدوة",
        funFact: "🌍 زلزال + شهادة = ارتداد السجان وأهل بيته!"
      }
    },

    76: {
      name: "في أثينا: أريوس باغوس",
      challenge: "الذي تتقونه بجهالة، هذا أنا أنادي لكم به...",
      easy: {
        question: "أي مذبح ذكره بولس في أثينا؟",
        options: [
          "للإله زيوس",
          "لإله مجهول",
          "لأبولو",
          "لأثينا"
        ],
        hint: "نقش غامض صار نقطة انطلاق",
        funFact: "🏛️ 'لإله مجهول' - نقطة التقاء رائعة مع الفلسفة اليونانية!"
      },
      medium: {
        question: "أمام من وعظ بولس في أثينا؟",
        options: [
          "الجمهور العام",
          "فلاسفة أبيقوريين ورواقيين في أريوس باغوس",
          "كهنة الهيكل",
          "الإمبراطور الروماني"
        ],
        hint: "النخبة الفكرية اليونانية",
        funFact: "🧠 أريوس باغوس = هارفارد القديمة - بولس أمام أعظم المفكرين!"
      },
      hard: {
        question: "كيف استجاب الأثينيون للقيامة؟",
        options: [
          "قبول إجماعي",
          "انقسام: بعضهم استهزأ وبعضهم أبدى اهتماماً",
          "غضب عام",
          "لامبالاة تامة"
        ],
        hint: "استجابة نموذجية للمثقفين لهذا السر",
        funFact: "🤔 القيامة = حجر عثرة للعقل البشري المتغطرس!"
      }
    },

    77: {
      name: "كورنثوس: بولس صانع الخيام",
      challenge: "فأقام عندهم وكان يعمل معهم، لأنه كان صانع خيام بالصنعة...",
      easy: {
        question: "ما المهنة التي مارسها بولس لكسب عيشه؟",
        options: [
          "صياد",
          "صانع خيام",
          "كاتب",
          "تاجر"
        ],
        hint: "حرفته اليدوية المتعلَّمة",
        funFact: "⛺ بولس: رسول·حرفي - كرامة العمل اليدوي بين المسيحيين!"
      },
      medium: {
        question: "في بيت من أقام بولس في كورنثوس؟",
        options: [
          "فندق",
          "بيت أكيلا وبريسكلا",
          "بيت الوالي",
          "المجمع"
        ],
        hint: "زوجان صانعا خيام مثله",
        funFact: "👫 أكيلا وبريسكلا: زوجان مبشران قدوة - ضيافة مسيحية!"
      },
      hard: {
        question: "لماذا عمل بولس بيديه؟",
        options: [
          "للحاجة المادية فقط",
          "لعدم إثقال أحد ولتأكيد الشهادة",
          "بسبب التقليد العائلي",
          "لأنه أحب المهنة"
        ],
        hint: "يتعلق بالاستقلالية والمصداقية",
        funFact: "💼 الاستقلال المادي = حرية الكلام - بولس لم يكن معتمداً على أحد!"
      }
    },

    78: {
      name: "الشغب في أفسس",
      challenge: "عظيمة هي أرطاميس الأفسسيين!",
      easy: {
        question: "من أثار الشغب ضد بولس في أفسس؟",
        options: [
          "السلطات الرومانية",
          "الصائغ ديمتريوس والحرفيون",
          "الفلاسفة",
          "كهنة يهود"
        ],
        hint: "صانعو هيكل أرطاميس",
        funFact: "🏛️ أول إضراب في التاريخ: الإنجيل يهدد اقتصاد الوثنية!"
      },
      medium: {
        question: "كم مدة علّم بولس في أفسس؟",
        options: [
          "6 أشهر",
          "سنة",
          "سنتان",
          "3 سنوات"
        ],
        hint: "أطول إقامة تبشيرية له",
        funFact: "📅 3 سنوات من التعليم المكثف - أفسس صارت مركز تبشير مهم!"
      },
      hard: {
        question: "ماذا يكشف هذا الشغب عن الأثر الاجتماعي للإنجيل؟",
        options: [
          "الإنجيل لا يغير شيئاً",
          "يحوّل البنى الاقتصادية والاجتماعية",
          "يخص الدين فقط",
          "يتجنب الصراع"
        ],
        hint: "يتعلق بالتحول الاجتماعي العميق",
        funFact: "💰 عندما يتقدم الإنجيل، تفقد الأوثان سوقها - أثر اقتصادي!"
      }
    }
  }
};

export default chapter6Translations;
